import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../util/ErrorAdd";

function RequestModalAdd({ show, onHide }) {

  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formName, setFormName] = useState(null);
  const [formDescription, setFormDescription] = useState(null);
  const [formContact, setFormContact] = useState(null);
  const [formRole, setFormRole] = useState(0);

  useEffect(() => {
    //Действия при открытии модального окна
    if (show === true) {


    }
    else {
      //ОЧИЩАЕМ ФОРМУ
      setFormName(null);
      setFormDescription(null);
      setFormContact(null);
      setFormRole(null);
      setLog(null);
      setLoading(false);
    }
  }, [show]);

  function addHundler() {
    setLoading(true);
    setLog(null);

    if (formName === null || formName === "") {
      setLog('Введите имя пользователя');
      setLoading(false);
    }
    else if (formContact === null || formContact === "") {
      setLog('Введите номер телефона или электронная почта');
      setLoading(false);
    }
    else if (formRole === null || formRole === "" || formRole == 0) {
      setLog('Выберите роль');
      setLoading(false);
    }
    else {
      axios.post('/api_main/company/requestAdminAdd', { Value_Contact: formContact, User_Name: formName, ID_Role: formRole, ID_Service: process.env.REACT_APP_ID_SERVICE, User_Description: formDescription })
        .then((res) => {
          if (res.data.Status === 1) {
            onHide();
          }
          else {
            setLog(res.data.Error);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLog('Неизвестная ошибка!');
          setLoading(false);
          ErrorAdd(err, window.location.href);
        });
    }
  }

  return (
    <>
      <Modal show={show} onHide={onHide} size="md">
        <Modal.Body>
          <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
          <div className="modal_title text-center mb-20">Добавление пользователя</div>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Имя пользователя в компании</Form.Label>
            <Form.Control type="text" disabled={loading} onChange={(e) => setFormName(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Электронная почта</Form.Label>
            <Form.Control type="text" disabled={loading} onChange={(e) => setFormContact(e.target.value)} />
          </Form.Group>
          <label className="form-label">Роль в компании</label>
          <div className="row">
            <div className="col-md-6">
              <button className={'param_button' + (formRole === 2 ? ' active' : '')} onClick={() => setFormRole(2)} >
                Пользователь
              </button>
            </div>
            <div className="col-md-6">
              <button className={'param_button' + (formRole === 1 ? ' active' : '')} onClick={() => setFormRole(1)} >
                Администратор
              </button>
            </div>
          </div>

          {log !== null && <div className="form_error text-center mt-15">{log}</div>}

          <div className="row mt-25">
            <div className="col-md-12 text-center">
              <SrvButton typeBtn="send" textBtn='Отправить заявку' size='lg' onClick={() => addHundler()} loading={loading} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default RequestModalAdd;
